'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppUserRegistrationState() {
}
export { $c_Lapp_data_AppUserRegistrationState as $c_Lapp_data_AppUserRegistrationState };
$p = $c_Lapp_data_AppUserRegistrationState.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppUserRegistrationState;
/** @constructor */
function $h_Lapp_data_AppUserRegistrationState() {
}
export { $h_Lapp_data_AppUserRegistrationState as $h_Lapp_data_AppUserRegistrationState };
$h_Lapp_data_AppUserRegistrationState.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.bth = (function() {
  if ((this instanceof $c_Lapp_data_AppUserRegistrationState$RegisteredAsViewer)) {
    return this.XP;
  }
  if ((this instanceof $c_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember)) {
    return this.XN;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
});
$p.bE3 = (function() {
  return ((this instanceof $c_Lapp_data_AppUserRegistrationState$RegisteredAsViewer) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(this) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$p.boj = (function() {
  return ((this instanceof $c_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(this) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
/** @constructor */
function $c_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember(user, id, details, prefs, member) {
  this.Lz = null;
  this.XM = null;
  this.XL = null;
  this.XO = null;
  this.XN = null;
  this.Lz = user;
  this.XM = id;
  this.XL = details;
  this.XO = prefs;
  this.XN = member;
}
export { $c_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember as $c_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember };
$p = $c_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember.prototype = new $h_Lapp_data_AppUserRegistrationState();
$p.constructor = $c_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember;
/** @constructor */
function $h_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember() {
}
export { $h_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember as $h_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember };
$h_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember)) {
    var x = this.Lz;
    var x$2 = x$0.Lz;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.XM;
      var x$4 = x$0.XM;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.XL;
      var x$6 = x$0.XL;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.XO;
      var x$8 = x$0.XO;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.XN;
      var x$10 = x$0.XN;
      return ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 5;
});
$p.t = (function() {
  return "RegisteredAsOrganizationMember";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.Lz;
      break;
    }
    case 1: {
      return this.XM;
      break;
    }
    case 2: {
      return this.XL;
      break;
    }
    case 3: {
      return this.XO;
      break;
    }
    case 4: {
      return this.XN;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "user";
      break;
    }
    case 1: {
      return "id";
      break;
    }
    case 2: {
      return "details";
      break;
    }
    case 3: {
      return "prefs";
      break;
    }
    case 4: {
      return "member";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.bsD = (function() {
  return this.XM;
});
$p.VN = (function() {
  return this.XL;
});
$p.a62 = (function() {
  return this.XO;
});
$p.co = (function() {
  return 1;
});
function $isArrayOf_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jc)));
}
export { $isArrayOf_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember as $isArrayOf_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember };
var $d_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember, "app.data.AppUserRegistrationState$RegisteredAsOrganizationMember", ({
  jc: 1,
  jb: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember as $d_Lapp_data_AppUserRegistrationState$RegisteredAsOrganizationMember };
/** @constructor */
function $c_Lapp_data_AppUserRegistrationState$RegisteredAsViewer(user, id, details, prefs, viewer) {
  this.LD = null;
  this.LB = null;
  this.LA = null;
  this.LC = null;
  this.XP = null;
  this.LD = user;
  this.LB = id;
  this.LA = details;
  this.LC = prefs;
  this.XP = viewer;
}
export { $c_Lapp_data_AppUserRegistrationState$RegisteredAsViewer as $c_Lapp_data_AppUserRegistrationState$RegisteredAsViewer };
$p = $c_Lapp_data_AppUserRegistrationState$RegisteredAsViewer.prototype = new $h_Lapp_data_AppUserRegistrationState();
$p.constructor = $c_Lapp_data_AppUserRegistrationState$RegisteredAsViewer;
/** @constructor */
function $h_Lapp_data_AppUserRegistrationState$RegisteredAsViewer() {
}
export { $h_Lapp_data_AppUserRegistrationState$RegisteredAsViewer as $h_Lapp_data_AppUserRegistrationState$RegisteredAsViewer };
$h_Lapp_data_AppUserRegistrationState$RegisteredAsViewer.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppUserRegistrationState$RegisteredAsViewer)) {
    var x = this.LD;
    var x$2 = x$0.LD;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.LB;
      var x$4 = x$0.LB;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.LA;
      var x$6 = x$0.LA;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.LC;
      var x$8 = x$0.LC;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.XP;
      var x$10 = x$0.XP;
      return ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 5;
});
$p.t = (function() {
  return "RegisteredAsViewer";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.LD;
      break;
    }
    case 1: {
      return this.LB;
      break;
    }
    case 2: {
      return this.LA;
      break;
    }
    case 3: {
      return this.LC;
      break;
    }
    case 4: {
      return this.XP;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "user";
      break;
    }
    case 1: {
      return "id";
      break;
    }
    case 2: {
      return "details";
      break;
    }
    case 3: {
      return "prefs";
      break;
    }
    case 4: {
      return "viewer";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.bsD = (function() {
  return this.LB;
});
$p.VN = (function() {
  return this.LA;
});
$p.a62 = (function() {
  return this.LC;
});
$p.co = (function() {
  return 0;
});
function $isArrayOf_Lapp_data_AppUserRegistrationState$RegisteredAsViewer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jd)));
}
export { $isArrayOf_Lapp_data_AppUserRegistrationState$RegisteredAsViewer as $isArrayOf_Lapp_data_AppUserRegistrationState$RegisteredAsViewer };
var $d_Lapp_data_AppUserRegistrationState$RegisteredAsViewer = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppUserRegistrationState$RegisteredAsViewer, "app.data.AppUserRegistrationState$RegisteredAsViewer", ({
  jd: 1,
  jb: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_AppUserRegistrationState$RegisteredAsViewer as $d_Lapp_data_AppUserRegistrationState$RegisteredAsViewer };
//# sourceMappingURL=app.data.-App-User-Registration-State.js.map
